<template>
  <div class="receive">
    <div v-if="activityInfo">
      <div class="banner">
        <img class="banner-image" :src="activityInfo.config.head_img" alt="" />
      </div>
      <div class="b-content">
        <div class="title">{{ activityInfo.config.title }}</div>
        <div class="time">
          <div v-if="!activityFinish" class="time-out"
            ><span>距离失效还剩：</span>
            <van-count-down
              :time="timeData"
              class="count-down"
              @finish="bindTimeFinish"
            >
              <template #default="timeData">
                <span>{{ timeData.days }}</span>
                <span class="colon">天</span>
                <span class="block">{{
                  timeData.hours <= 9 ? '0' + timeData.hours : timeData.hours
                }}</span>
                <span class="colon">:</span>
                <span class="block">{{
                  timeData.minutes <= 9
                    ? '0' + timeData.minutes
                    : timeData.minutes
                }}</span>
                <span class="colon">:</span>
                <span class="block">{{
                  timeData.seconds <= 9
                    ? '0' + timeData.seconds
                    : timeData.seconds
                }}</span>
              </template>
            </van-count-down>
          </div>
          <div v-else>活动已结束</div>
        </div>
        <div class="b-item">
          <div class="b-item-top">
            <div
              ><span class="b-title">已转换金额:</span>
              <span class="exchange-num">{{
                parseFloat(activityInfo.accrue_price)
              }}</span>
            </div>
            <div class="exchange-btn" @click="bindToExchange"
              >订单转换<span class="iconfont icon-you"></span
            ></div>
          </div>
          <div class="tips">
            <div>{{ activityInfo.config.content }}</div>
            <div
              >赠品<span class="pink">仅能选择1个</span>，请宝宝们谨慎选择~</div
            >
          </div>
          <div class="prize-container">
            <div class="prize-list">
              <div
                class="prize-item"
                v-for="(item, index) in activityInfo.gift"
                :key="index"
                @click="bindClickPrize(item)"
              >
                <!--  <div class="prize-flag">满{{ item.price }}赠</div> -->
                <div class="prize-bg">
                  <img class="prize-image" :src="item.goods_img" alt="" />
                </div>
                <div class="prize-name">{{ item.goods_name }}</div>
                <div class="prize-desc"
                  >转换金额满<span class="desc-bold">{{ item.price }}</span
                  >可选
                </div>
                <div
                  class="prize-btn"
                  :class="{ 'prize-btn-disabled': item.disabledBtn }"
                  >{{ item.btnText }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 已转换订单 -->
        <div class="b-item">
          <div class="b-item-top">
            <div><span class="b-title">已转换订单</span></div>
            <div class="exchange-tips">{{
              activityInfo.config.order_content
            }}</div>
          </div>
          <div class="order-container">
            <van-list v-model="loading" :finished="finished" @load="getRecord">
              <div class="order-list">
                <div
                  class="order-item"
                  v-for="(item, index) in recordList"
                  :key="index"
                >
                  <img
                    class="order-item-icon"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b3832b01b718e156ad157834e762446f.png"
                    alt=""
                  />
                  <div class="order-item-center">
                    <div class="order-item-id">{{ item.order_id }}</div>
                    <div class="order-item-time">{{ item.created_at }}</div>
                  </div>
                  <div class="order-item-num"
                    >转换金额 ¥{{ parseFloat(item.price) }}</div
                  >
                </div>
              </div>
              <div class="not-more" v-if="finished">没有更多了</div>
            </van-list>
          </div>
        </div>
        <!-- 规则 -->
        <img class="rule-image" :src="activityInfo.config.rule_img" alt="" />
        <!-- <div class="b-item">
                    <div class="b-item-top">
                        <div><span class="b-title">活动规则</span></div>
                    </div>
                    <div class="rule-container">
                        <div class="rule-item" v-for="(item, index) in rule" :key="index">
                            <div class="rule-index">{{ item.index }}</div>
                            <div class="rule-text">{{ item.text }}</div>
                        </div>
                    </div>
                </div> -->
      </div>
      <!-- 弹框 -->
      <van-overlay :show="showToast" @click="showToast = false">
        <PrizeToast
          :data="prizeToastData"
          @confirm="bindPrizeConfirm"
          @cancel="bindPrizeCancel"
        />
      </van-overlay>
      <van-overlay :show="showSuccessToast" @click="showSuccessToast = false">
        <ReceiveSuccessToast
          :data="receiveToastData"
          @confirm="bindReceiveConfirm"
          @cancel="bindReceiveCancel"
        />
      </van-overlay>
    </div>
    <AppLoading class="app-loading" v-if="!pageLoaded" />
  </div>
</template>
<script>
import AppLoading from '@/components/app/loading/loading.vue'
import PrizeToast from './components/prize-toast.vue'
import ReceiveSuccessToast from './components/receive-success-toast.vue'
export default {
  components: {
    PrizeToast,
    ReceiveSuccessToast,
    AppLoading
  },
  data() {
    return {
      activityFinish: true,
      pageLoaded: false,
      rule: [
        {
          index: '01',
          text: '23.10.1-23.11.30期间购买了一对一瘦身包(2月)或一对一瘦身包(4月)的新会员，在23.11.1-23.11.30开卡激活'
        },
        {
          index: '02',
          text: '会员在激活后 30 天内在第 10 次课程时，可获得一次抽奖机会，必中健萌周边好礼(以健萌约课系统中记录的扫码上课数为淮）'
        },
        {
          index: '03',
          text: '会员激活卡后若产生停卡，也会计算在激活后 30 天的时间内 (即 11 月份若停卡了 10 天还满足 10 次课程也可获得礼品，若不满足 10 次课程，则无法获得礼品）'
        }
      ],
      recordList: [],
      timeData: 0,
      isEnd: false,
      loading: false,
      finished: false,
      page: 1,
      activityInfo: null,
      showToast: false,
      prizeToastData: null,
      showSuccessToast: false,
      receiveToastData: null
    }
  },
  created() {
    this.checkLogin()
    this.getActivityData()
  },
  methods: {
    checkLogin() {
      this.gym_code = this.$http._getCookie('token')
      if (!this.gym_code && !this.$route.query.refresh) {
        let url = location.href
        let params = url.includes('?') ? '&refresh=1' : '?refresh=1'
        url = url + params
        location.href =
          'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_userinfo&next=' +
          encodeURIComponent(url)
      }
    },
    bindTimeFinish() {
      this.activityFinish = true
    },
    computedActivityStatus(endTimeStr, curTime) {
      let endTime = new Date(endTimeStr.replace(/-/g, '/'))
      curTime = curTime * 1000
      if (curTime >= endTime) {
        this.activityFinish = true
      } else {
        this.activityFinish = false
        this.timeData = endTime - curTime
      }
    },
    bindToExchange() {
      this.$router.push('/integral-exchange/exchange')
    },
    async getActivityData() {
      let params = {
        config_id: this.$route.query.activityId,
        token: this.$http._getCookie('dy-integral-token')
      }
      let res = await this.$http
        .getApp('api/v1/IntegralConversionCenter/unStackGiftConfig', params)
        .catch(() => {})
      this.pageLoaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityInfo = res.data
          this.activityInfo = this.dealData(res.data, res.time)
          this.computedActivityStatus(
            this.activityInfo.config.expire_time,
            res.time
          )
        }
      }
    },
    async getRecord() {
      let params = {
        config_id: this.$route.query.activityId,
        page: this.page,
        limit: 20,
        token: this.$http._getCookie('dy-integral-token')
      }
      let res = await this.$http
        .getApp('api/v1/IntegralConversionCenter/unStackGiftLog', params)
        .catch(() => {
          this.finished = true
        })
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.page++
          if (res.data.length) {
            this.recordList = this.recordList.concat(res.data)
          } else {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      }
    },
    bindClickPrize(item) {
      if (this.activityInfo.isEnd) {
        this.$toast('活动已结束')
        return
      }
      if (!this.activityInfo.isReceive && item.disabledBtn) {
        this.$toast('暂不满足可选条件，快去转换订单吧~')
        return
      }
      if (!item.disabledBtn) {
        if (this.activityInfo.isReceive) {
          location.href = item.goods_url
        } else {
          this.prizeToastData = item
          this.showToast = true
        }
      }
    },
    //处理数据 计算按钮禁用状态
    dealData(data, curTime) {
      data.accrue_price = +data.accrue_price
      if (data.gift) {
        let isReceive = data.gift.find((item) => {
          return item.exchange
        })
        data.isReceive = !!isReceive
        data.isEnd =
          curTime * 1000 -
            new Date(data.config.expire_time.replace(/-/g, '/')) >=
          0
        data.gift.map((item) => {
          item.price = +item.price
          //按钮文字
          item.btnText = data.isEnd
            ? '活动已结束'
            : item.exchange
            ? '已领取'
            : '领取'
          //按钮禁用颜色状态
          if (item.exchange) {
            item.disabledBtn = false
          } else {
            if (isReceive) {
              item.disabledBtn = true
            } else {
              item.disabledBtn = item.price > data.accrue_price
            }
          }
        })
      }
      return data
    },
    async bindPrizeConfirm(item) {
      let params = {
        gift_id: item.id,
        token: this.$http._getCookie('dy-integral-token')
      }
      let res = await this.$http
        .postApp(
          'api/v1/IntegralConversionCenter/exchangeUnStackGiftLog',
          params
        )
        .catch(() => {})
      this.showToast = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          ;(this.receiveToastData = item), (this.showSuccessToast = true)
          this.getActivityData()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindPrizeCancel() {
      this.showToast = false
    },
    bindReceiveConfirm(item) {
      this.showSuccessToast = false
      if (item?.goods_url) {
        location.href = item.goods_url
      }
    },
    bindReceiveCancel() {
      this.showSuccessToast = false
    }
  }
}
</script>
<style lang="scss" scoped>
.app-loading {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.receive {
  .banner {
    width: 100%;
    height: 217px;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .b-content {
    min-height: calc(100vh - 196px);
    position: relative;
    box-sizing: border-box;
    margin-top: -20px;
    background: #f9f9f9;
    padding: 20px 16px;
    border-radius: 20px 20px 0px 0px;

    .title {
      text-align: center;
      font-size: 19px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #35271b;
      line-height: 26px;
      margin-bottom: 7px;
    }

    .time {
      text-align: center;
      min-width: 236px;
      height: 30px;
      background: rgba(255, 185, 86, 0.15);
      border-radius: 15px;
      margin: 0 auto 20px;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #c47f2f;
      display: flex;
      align-items: center;
      justify-content: center;

      .count-down {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #c47f2f;
        line-height: 16px;

        .colon {
          display: inline-block;
          margin: 0 4px;
        }

        .block {
          display: inline-block;
          min-width: 16px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background-color: rgba(196, 127, 47, 1);
          border-radius: 4px;
        }
      }

      .time-out {
        display: flex;
        align-items: center;
      }
    }

    .b-item {
      background: linear-gradient(143deg, #fdf8ed 0px, #ffffff 343px);
      border-radius: 12px;
      padding: 16px 16px 20px;
      margin-bottom: 16px;

      .b-item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;

        .exchange-num {
          max-width: 150px;
          font-size: 18px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #c47f2f;
          line-height: 25px;
          margin-left: 8px;
        }

        .exchange-btn {
          padding: 0 8px 0px 13px;
          height: 23px;
          line-height: 23px;
          border-radius: 18px;
          display: flex;
          background: #f1ae54;
          align-items: center;
          font-size: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #fff;
        }

        .exchange-tips {
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 19px;
        }

        .b-title {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          color: #35271b;
          line-height: 22px;
          position: relative;
          z-index: 1;
        }

        .b-title::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -2px;
          width: 100%;
          height: 8px;
          background: linear-gradient(
            270deg,
            rgba(220, 153, 64, 0),
            rgba(243, 176, 78, 1)
          );
          z-index: -1;
        }
      }

      .tips {
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 19px;
        margin-bottom: 16px;
        text-align: center;

        .pink {
          color: rgba(242, 58, 93, 1);
        }
      }

      .prize-container {
        width: 100%;
        overflow-x: scroll;

        .prize-list {
          display: inline-flex;
          padding: 0px 7px;

          .prize-item {
            position: relative;
            width: 138px;
            box-sizing: border-box;
            background: #fff5e1;
            border-radius: 6px;
            overflow: hidden;
            padding: 10px 11px 12px;
            text-align: center;
            margin-right: 20px;

            .prize-flag {
              min-width: 59px;
              box-sizing: border-box;
              text-align: center;
              position: absolute;
              left: 0;
              top: 0;
              background: #533e2c;
              border-radius: 6px 0px 6px 0px;
              padding: 0px 6px;
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #fff8d1;
              line-height: 21px;
            }

            .prize-bg {
              width: 116px;
              height: 116px;
              background: #ffffff;
              border-radius: 6px;
              margin-bottom: 10px;

              .prize-image {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }

            .prize-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 18px;
            }

            .prize-desc {
              font-size: 10px;
              font-family: PingFangSC, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 18px;
              margin-bottom: 6px;

              .desc-bold {
                color: rgba(196, 127, 47, 1);
              }
            }

            .prize-btn {
              margin: 0 auto;
              width: 108px;
              height: 26px;
              background: #f1ae54;
              border-radius: 18px;
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: #ffffff;
              line-height: 26px;
            }

            .prize-btn-disabled {
              background: rgba(241, 174, 84, 0.5);
            }
          }

          .prize-item:last-child {
            margin-right: 0;
          }
        }
      }

      .order-container {
        background: #fbfbfb;
        padding-bottom: 20px;

        .not-more {
          font-size: 10px;
          text-align: center;
          color: rgba(0, 0, 0, 0.6);
        }

        .order-list {
          border-radius: 8px;
          padding: 9px 12px 8px;

          .order-item {
            display: flex;
            align-items: center;
            padding: 11px 0px 12px;
            border-bottom: 1px dashed #e2e2e2;

            .order-item-icon {
              width: 25px;
              height: 25px;
              margin-right: 12px;
            }

            .order-item-center {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;

              .order-item-id {
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: bold;
                color: rgba(0, 0, 0, 0.7);
                line-height: 17px;
              }

              .order-item-time {
                font-size: 10px;
                font-family: PingFangSC, PingFang SC;
                color: rgba(0, 0, 0, 0.5);
                line-height: 14px;
              }
            }

            .order-item-num {
              margin-left: 10px;
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 17px;
            }
          }

          .order-item:last-child {
            border-bottom: none;
          }
        }
      }

      .rule-container {
        .rule-item {
          display: flex;
          align-items: flex-start;

          .rule-index {
            font-size: 15px;
            font-family: MiSans, MiSans;
            font-weight: bold;
            color: #c37f24;
            line-height: 20px;
            margin-right: 9px;
          }

          .rule-text {
            font-size: 12px;
            font-family: MiSans, MiSans;
            color: rgba(0, 0, 0, 0.6);
            line-height: 18px;
          }
        }
      }
    }

    .rule-image {
      border-radius: 12px;
      overflow: hidden;
      width: 100%;
    }
  }
}
</style>
